module.exports = __webpack_public_path__ + "static/2-5563fbdacae564c8f32b59c5436fa562.jpeg";